@let testIdPrefix = 'rcp-' + nameId() + '-bottom-sheet';
<div
    class="rcp-flex rcp-max-h-full rcp-flex-col rcp-justify-center"
    [attr.data-testid]="testIdPrefix"
>
    <div
        class="rcp-sticky rcp-top-0 rcp-w-full rcp-self-start rcp-border-b rcp-border-ul-gray-350 rcp-p-6"
    >
        <div class="rcp-flex rcp-items-center rcp-justify-between">
            @if (titleAlignment() === 'left') {
                <div class="lg:rcp-ps-10"></div>
            }
            <h3
                [class]="titleClass()"
                [attr.data-testid]="'title' | testid: testIdPrefix"
            >
                {{ title() }}
            </h3>
            <button
                matRipple
                type="button"
                class="rcp-inline-flex rcp-rounded-full rcp-bg-ul-gray-250 rcp-p-2 rcp-text-black"
                [attr.data-testid]="'close-btn' | testid: testIdPrefix"
                (click)="onCloseClick($event)"
            >
                <mat-icon>close</mat-icon>
            </button>
        </div>
        @if (readonlyStepper().items.length > 0) {
            <div class="rcp-w-full">
                <div
                    class="rcp-mx-auto rcp-max-w-[400px]"
                    id="customReadOnlyStepperHeader"
                >
                    <mat-stepper
                        #stepper
                        labelPosition="bottom"
                        linear
                        [attr.data-testid]="'list' | testid: testIdPrefix"
                    >
                        @for (step of readonlyStepper().items; track $index) {
                            @if (readonlyStepper().completed) {
                                <mat-step
                                    state="done"
                                    editable="false"
                                    completed
                                    [attr.data-testid]="
                                        'step-' + step
                                            | testid: testIdPrefix : 'completed'
                                    "
                                >
                                    <ng-template matStepLabel
                                        ><span
                                            [attr.data-testid]="
                                                'step-' +
                                                    step
                                                        .toLocaleLowerCase()
                                                        .replace(' ', '-')
                                                    | testid: testIdPrefix : 'completed'
                                            "
                                        >
                                            {{ step }}
                                        </span></ng-template
                                    >
                                </mat-step>
                            } @else {
                                <mat-step
                                    state="number"
                                    editable="false"
                                    [attr.data-testid]="
                                        'step-' + step | testid: testIdPrefix
                                    "
                                >
                                    <ng-template matStepLabel
                                        ><span
                                            [attr.data-testid]="
                                                'step-' +
                                                    step
                                                        .toLocaleLowerCase()
                                                        .replace(' ', '-')
                                                    | testid: testIdPrefix
                                            "
                                        >
                                            {{ step }}
                                        </span></ng-template
                                    >
                                </mat-step>
                            }
                            <ng-template matStepperIcon="edit">
                                {{ $index + 1 }}
                            </ng-template>
                        }
                    </mat-stepper>
                </div>
            </div>
        }
    </div>
    <div
        class="rcp-w-full rcp-overflow-auto rcp-px-4 rcp-pb-20 rcp-pt-12"
        [attr.data-testid]="'content' | testid: testIdPrefix"
    >
        <div class="{{ bodyClass() }}">
            <ng-content></ng-content>
        </div>
    </div>
</div>
